<template>
    <tr :id="item.id" :key="item.id" :class="{'mark-as-important': item.priority == 1}">
        <td>
            <div class="form-check">
                <input class="form-check-input" type="checkbox" name="selectedOrderForDelete" v-model="selectedOrderForDelete" :value="item.id">
            </div>
        </td>
        <td>
            <router-link :to="{ name: 'purchaseOrderShow', params: { id: item.id }}" class="edit-btn">#{{ item.po_number }}</router-link>
        </td>
        <td>{{ item.eta }}</td>
        <td>
            <router-link v-if="item.vendor" target="_blank" :to="{ name: 'vendorDetails', params: { id: item.vendor_id }}" class="edit-btn">
            {{ item.vendor.company_name }}
            </router-link>
        </td>
        <td>
            <router-link v-if="item.order && item.order.customer" target="_blank" :to="{ name: 'customerDetails', params: { id: item.order.customer.id }}" class="edit-btn">
            {{ item.order.customer ? item.order.customer.company_name : '' }}
            </router-link>
        </td>
        <td>${{ item.amount }}</td>
        <td>{{ item.added_by ? item.added_by.name : '' }}</td>
        <td>{{ item.created_at_date }}</td>
        <td>{{ item.updated_at_date }}</td>
        <td><span :class="formatStatusClass(item)">{{ item.purchase_order_status ? item.purchase_order_status.name : "" }}</span></td>

        <td>
            <template v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('edit-purchase-order')">
                <router-link :to="{ name: 'purchaseOrderShow', params: { id: item.id }}" class="edit-btn" style="font-size: 18px;"><i  class="ri-edit-box-line me-1"></i></router-link>
            </template>
            <a  href="javascript:void(0);" v-if="(getUser!= null && getUser.user_type == 1) || hasRole('Admin') || hasPerm('delete-purchase-order')" v-on:click="removeItem(item.id)" class="del_btn" title="Delete Order" ><i class="ri-delete-bin-6-line"></i></a>
        </td>
    </tr>
</template>

<script>
import Vue from "vue";

export default {
    name: "PurchaseOrderListItem",
    props: ['item', 'bus',],
    mounted() {
        this.bus.$on('checkOrdersForDelete', (event) => {
            this.selectedOrderForDelete = event;
        });
    },
    data(){
        return {
            selectedOrderForDelete: false
        }
    },
    methods: {
        removeItem(id){
            Vue.$confirm({
                title: 'Are you sure?',
                message: 'Are you sure you want to delete order?',
                button: {
                    yes: 'Yes',
                    no: 'Cancel'
                },
                callback: confirm => {
                    if(confirm) {
                        this.$emit('deleteItem', {id: id});
                    }

                }
            })
        },
        formatStatusClass(item) {
            if(item.purchase_order_status) {
                return item.purchase_order_status.name.replace(/\s+/g, '-').replace("/", "-").toLowerCase();
            }
            return "";
        }
    },
    watch: {
        selectedOrderForDelete: {
            handler: function(value) {
                this.$emit('changeSelectedOrderForDelete', {checked: value, id: this.item.id});
            }
        },
        item: {
            handler: function (value) {
                this.selectedOrderForDelete = false
            }
        }
    },
}
</script>

<style scoped>

</style>
